// extracted by mini-css-extract-plugin
export default {"placeholder":"RowRenderer_placeholder__kDib6"};